import { render } from "./ModalDeviceData.vue?vue&type=template&id=5981dc5e"
import script from "./ModalDeviceData.vue?vue&type=script&lang=js"
export * from "./ModalDeviceData.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/ru/components/modals/modal-device-data.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fmodals%2FModalDeviceData.vue&locale=ru"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locales/en/components/modals/modal-device-data.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fmodals%2FModalDeviceData.vue&locale=en"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__